import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const Image = ({ src }) => {

  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "newspapers" } }) {
        nodes {
          name
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  `)

  let theImg = data.allFile.nodes.find(node => src === node.name);

  if (theImg === undefined) {
    return null
  }

  return <GatsbyImage image={theImg && theImg.childImageSharp.gatsbyImageData} alt={src} />
}

export default Image
